import isUrl from "is-url";

export const isImageUrl = (url: string) => {
  return isUrl(url) && /\.(?:jpe?g|png|gif|bmp)$/i.test(url);
};
